export default {
    blue_header: '#1988c8',
    blue_text: '#0c699e',
    lightblue_bg: '#e2f6fd',
    red_highlight: '#e14e74',
    lightred_bg: '#fde7ed',
    light_grey: '#dbdbdb',
};
